/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/paging/page',['require','jquery','underscore','backbone','marionette','modules/paging/paging-object','json!content/schemas.json','core/templates'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Marionette = require('marionette');
  var PagingObject = require('modules/paging/paging-object');
  var Schemas = require('json!content/schemas.json');
  var templates = require('core/templates');

  var Engine;
  require(['core/engine'], function(a) {
    Engine = a;
  });

  /*****************************************************************************************************************///}

  var Page = PagingObject.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    defaults: function()
    {
      var inherited = PagingObject.prototype.defaults.apply(this, arguments);

      return _.assign(inherited, {
        data             : new Backbone.Model(),
        schema           : { },
        ViewClass        : null,
        view             : '',
        name             : '',
        loaded           : false,
        type             : 'page'
      });
    },

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ////console.log('Page::initialize');

      if (!this.has('layout'))
        this.set('layout', this.getViewType());

      if (this.get('id') === 'menu' && Engine.config.mapSettings.menuJSON)
        this.set('filename', Engine.config.mapSettings.menuJSON);

      PagingObject.prototype.initialize.apply(this, arguments);
    },

    setActive: function()
    {
      this.radio.trigger('page.active', this);

      PagingObject.prototype.setActive.apply(this, arguments);
    },

    create: function()
    {
      var View = this.get('ViewClass') || Marionette.ItemView;

      return new View({ model: this.get('data').clone(), page: this, template: this.getTemplate() });
    },

    load: function()
    {
      console.log('page.load');
      var self = this;
      if (this.get('loaded'))
      {
        //console.log('Page already loaded', this);
        _.defer(function() {
          self.trigger('page.ready');
        });
        return;
      }

      var done = _.after(3, function()
      {
        console.log('after');
        self.set('loaded', true);
        self.trigger('page.ready');
      });

      this.on('page.schemaloaded', done, this);
      this.on('page.classloaded', done, this);
      this.on('page.dataloaded', done, this);

      // load all the things
      //this.loadSchema(done);
      this.trigger('page.schemaloaded');
      this.loadClass();
      this.loadData();
    },

    loadSchema: function()
    {
      var schemaPath = this.getViewType();
      var schema = Schemas[schemaPath];

      if (schema)
      {
        this.set('schema', schema, { silent: true });
        this.trigger('page.schemaloaded');
      }
      else
      {
        console.warn('Schema not found: ' + schemaPath + '.schema');
      }
    },

    loadClass: function()
    {
      var viewPath = this.getViewPath();
      var self = this;
      require([viewPath], function(View)
      {
        self.set('ViewClass', View, { silent: true });
        self.trigger('page.classloaded');
      });
    },

    loadData: function(_retry)
    {
      _retry = _retry === undefined ? true : false;
      var self = this;
      var filename = this.get('filename') || this.get('id');
      var dataPath = 'json!content/json/' + filename + '.json';
      if (!_retry)
        dataPath += '?rand=' + Math.round(Math.random() * 99999).toString();

      require([dataPath],
        function(data)
        {
          self.get('data').set(data, { silent: true });
          self.trigger('page.dataloaded');
        },
        function(err)
        {
          if (_retry)
          {
            _.delay(_.bind(self.loadData, self, false), 500);
          }
          else
          {
            console.error('Data not found: ' + self.get('id') + '.json', err);
            self.generateDefault();
          }
        }
      );
    },

    generateDefault: function()
    {
      //console.log('Generating default data from schema');

      if (!window.JSONEditor)
      {
        console.warn('JSONEditor not found!');
        this.get('data').set({ }, { silent: true });
        this.trigger('page.dataloaded');
        return;
      }

      var editor = new window.JSONEditor($('<div>')[0], { schema: this.get('schema') });

      var self = this;
      editor.on('ready', function()
      {
        self.get('data').set(editor.getValue(), { silent: true });
        editor.destroy();
        self.trigger('page.dataloaded');
      });
    },

    serialize: function()
    {
      var data = {
        complete: this.attributes.complete
      };

      if (this.get('unlock') !== undefined)
      {
        data.locked = this.get('locked');
        data.earnedPoints = this.get('earnedPoints');
      }

      if (_.size(this.get('storage')))
        data.storage = this.get('storage');

      return data;
    },

    deserialize: function(data)
    {
      PagingObject.prototype.deserialize.apply(this, arguments);
    },

    getPathing: function(prop)
    {
      var viewPath = this.get('view');
      var propPath = this.get(prop) || viewPath;

      var pathString = 'screens/';

      if (propPath.indexOf('/') === -1) // update pathing based on assumption that view name is same as subfolder
        pathString += viewPath + '/' + propPath;
      else
        pathString += propPath;

      return pathString;
    },

    getViewType: function()
    {
      var viewPath = this.get('view');
      return viewPath.substr(viewPath.lastIndexOf('/') + 1);
    },

    getViewPath: function()
    {
      return this.getPathing('view');
    },

    getLayout: function()
    {
      var layout = '';
      var viewPath = this.get('view');

      layout += viewPath.split('/').join(' ');
      layout += ' ' + this.get('layout');

      return layout;
    },

    getTemplate: function()
    {
      var tmplString = this.getPathing('html');

      return templates[tmplString];
    }

  /*****************************************************************************************************************///}

  });

  return Page;

});

